const SESSION_KEY = 'andhraYatriVendorSession';
const LOCAL_VENDORS_KEY = 'andhraYatriLocalVendors';
const SESSION_EVENT = 'andhra-yatri-vendor-auth-change';

export function getVendorSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    clearVendorSession();
    return null;
  }
}

export function saveVendorSession(session) {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  window.dispatchEvent(new Event(SESSION_EVENT));
}

export function clearVendorSession() {
  localStorage.removeItem(SESSION_KEY);
  window.dispatchEvent(new Event(SESSION_EVENT));
}

export function onVendorSessionChange(callback) {
  const handler = () => callback(getVendorSession());
  window.addEventListener(SESSION_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(SESSION_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function getLocalVendors() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_VENDORS_KEY)) || [];
  } catch {
    return [];
  }
}

export function saveLocalVendor(vendor) {
  const vendors = getLocalVendors();
  const normalizedEmail = String(vendor.email || '').trim().toLowerCase();
  const generatedId = vendor.id || vendor._id || `local-vendor-${Date.now()}`;
  const nextVendor = {
    ...vendor,
    id: generatedId,
    _id: vendor._id || vendor.id || generatedId,
    businessName: vendor.businessName,
    name: vendor.name || vendor.ownerName,
    email: normalizedEmail,
    mobile: vendor.mobile,
    password: vendor.password,
    category: vendor.category || vendor.categoryId || '',
    categoryId: vendor.categoryId || vendor.category || '',
    status: vendor.status || 'Pending',
    rejectionReason: vendor.rejectionReason || '',
    submissionReferenceId: vendor.submissionReferenceId || '',
    estimatedReviewDate: vendor.estimatedReviewDate || '',
    createdAt: vendor.createdAt || new Date().toISOString(),
  };
  const others = vendors.filter((item) => String(item.email || '').toLowerCase() !== normalizedEmail);
  const next = [nextVendor, ...others].slice(0, 20);
  localStorage.setItem(LOCAL_VENDORS_KEY, JSON.stringify(next));
  return nextVendor;
}

export function findLocalVendor({ email, password }) {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  return getLocalVendors().find((vendor) => (
    String(vendor.email || '').toLowerCase() === normalizedEmail &&
    vendor.password === password
  )) || null;
}

export function normalizeVendorStatus(status) {
  const normalized = String(status || '').trim().toLowerCase();
  if (normalized === 'approved' || normalized === 'active' || normalized === 'accepted') {
    return 'approved';
  }
  if (normalized === 'rejected') {
    return 'rejected';
  }
  if (normalized === 'expired') {
    return 'expired';
  }
  if (normalized === 'suspended') {
    return 'suspended';
  }
  if (normalized === 'draft') {
    return 'draft';
  }
  if (normalized === 'submitted') {
    return 'submitted';
  }
  if (normalized === 'pending_review' || normalized === 'pendingreview') {
    return 'pending_review';
  }
  if (normalized === 'under_verification' || normalized === 'underverification') {
    return 'under_verification';
  }
  return 'pending';
}

export { SESSION_EVENT };
